export default __webpack_public_path__ + "static/cabin-basic-2-to-6-1-4d2aa30edbf69ce8d3ece336dad71e60.jpg";